import { useDictionary, useParameter } from "../../../shared";
import { SLIDE_NUMBER } from "../constants";
import { dictionaryService } from "../../../dataFlow";

export function useGrowthChartTitle(): string {
  const [commodityValue] = useParameter<number>("@commodities");
  const [dictItems] = useDictionary(dictionaryService, "slides-commodities-display", undefined, {
    business_unit: 1,
    slide: SLIDE_NUMBER,
  });
  
  const commodityDictItem = dictItems?.find(dictItem => Number(dictItem.getValue<number>("olap_commodity")) === commodityValue);
  const commodityName = commodityDictItem ? (commodityDictItem.getValue("name") as any)[9] :  "";
  
  return `${commodityName} growth`;
}